import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./UnregisteredStudentsUIHelpers";

const UnregisteredStudentsUIContext = createContext();

export function useUnregisteredStudentsUIContext() {
  return useContext(UnregisteredStudentsUIContext);
}

export const UnregisteredStudentsUIConsumer = UnregisteredStudentsUIContext.Consumer;

export function UnregisteredStudentsUIProvider({ studentsUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewStudentPage: studentsUIEvents.openNewStudentPage,
    openEditStudentPage: studentsUIEvents.openEditStudentPage,
    openFinalRegistrationPage: studentsUIEvents.openFinalRegistrationPage
  };

  return (
    <UnregisteredStudentsUIContext.Provider value={value}>
      {children}
    </UnregisteredStudentsUIContext.Provider>
  );
}